import AlgorithmDashboard from './components/AlgorithmDashboard';

function App() {
  return (
    <div className="App">
      <AlgorithmDashboard />
    </div>
  );
}

export default App;